import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-header-menu-template]' })
export class GridHeaderMenuTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
